module.exports = __webpack_public_path__ + "img/bg_mine@2x.c3fa3996.png";